import React, { Component } from "react";
import { Divider, Typography, Button } from "@mui/material";
import "./css/InverterSelectorForm.css";
import logo from "../assets/logo.svg";
import "./css/HeaderViewForm.css";

export class HeaderView extends Component {
  render() {
    return (
      //App starts here
      <div className="">
        {/* <div>
          <div>
            <img className="logo-header" src={logo} alt="Logo"></img>
          </div>
          <div>
          <Typography
            fontSize="30px"
            className="header-text"
            style={{ fontFamily: "Ford-SemiBold" }}
          >
            UL924 Inverter Selector
          </Typography>
          </div>
          <div>

          </div>
        </div> */}
        <div className="header-title-area">
          <img className="logo-header" src={logo} alt="Logo"></img>
          <Typography
            fontSize="30px"
            className="header-text"
            //backgroundColor= "red"
            align="center"
            style={{ fontFamily: "Ford-SemiBold" , textAlign: "center"}}
          >
            UL924 Inverter Selector
          </Typography>
          <p
            className="header-title-description"
            style={{ fontFamily: "Ford-Medium" }}
            
          >
            Discover your ideal emergency lighting inverter with our UL924
            Inverter Selector. Get a customized report with model, capacity, and
            all the essential details for your lighting system. Streamline your
            planning and ensure reliability with ease!
          </p>
        </div>
        <Divider className="header-divider">
          <Button
            style={{
              backgroundColor: "#0d52ae",
              color: "#ffffff",
              fontFamily: "Ford-Bold",
            }}
            variant="contained"
            onClick={(event) => {
              window.open("https://onlinepower.com/selector/form.html");
            }}
          >
            {" "}
            Request Information
          </Button>
        </Divider>
      </div>
    );
  }
}

export default HeaderView;
